import { render, staticRenderFns } from "./classPartnerOrder.vue?vue&type=template&id=5a13277a&scoped=true"
import script from "./classPartnerOrder.vue?vue&type=script&lang=js"
export * from "./classPartnerOrder.vue?vue&type=script&lang=js"
import style0 from "./classPartnerOrder.vue?vue&type=style&index=0&id=5a13277a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a13277a",
  null
  
)

export default component.exports